var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.13 7.55a3.274 3.274 0 0 1 2.303 2.304c.55 2.036.567 6.258.567 6.258s0 4.238-.55 6.258a3.274 3.274 0 0 1-2.304 2.303c-2.019.55-10.146.55-10.146.55s-8.127 0-10.146-.55A3.274 3.274 0 0 1 3.55 22.37C3 20.334 3 16.112 3 16.112s0-4.222.534-6.242a3.274 3.274 0 0 1 2.303-2.303C7.857 7.017 15.983 7 15.983 7s8.127 0 10.147.55Zm-5.991 8.562-6.742 3.905v-7.81l6.742 3.905Z",
    fill: "currentColor"
  })));
};
export default SvgYoutube;